import { format } from "date-fns";

/**
 * Converts server date string to local Date object
 * @param serverDateString - Date from server (YYYY-MM-DD or YYYY-MM-DDTHH:MM:SS[Z])
 * - Date-only: treated as local midnight (no timezone conversion)
 * - DateTime without Z: treated as UTC, converted to local
 * - DateTime with Z: browser handles UTC conversion
 */
export const getLocalDate = (serverDateString: string) => {
  if (serverDateString.length === "YYYY-MM-DD".length) {
    // It's a date-part in the format YYYY-MM-DD
    // fill in the missing time part and don't convert to local time
    return new Date(serverDateString + "T00:00:00");
  } else if (!serverDateString.endsWith("Z")) {
    // It's a date-time in the format YYYY-MM-DDTHH:MM:SS
    // append a Z to tell the browser it's a UTC date-time
    serverDateString += "Z";
  }
  // It's a date-time in the format YYYY-MM-DDTHH:MM:SSZ
  // the browser will convert it to local time, let it!
  return new Date(serverDateString);
};

export const formatLocalDate = (
  dateString: string | undefined | null,
  formatString = "MM/dd/yyyy"
) => {
  if (!dateString) return "";
  return format(getLocalDate(dateString), formatString);
};
